import React, { Component } from "react";
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import { Bezier2, KanbanFill, ShareFill, WalletFill, CheckSquareFill, ArrowRepeat } from 'react-bootstrap-icons';
import "./App.css";
import NavTop from "./NavTop";
import Roadmap from "./Roadmap";
import NavBottom from "./NavBottom";

class App extends Component {
    render() {
        return (

                <div className="App backColor App-font">
                    <Container fluid>
                  <div className="App-main-image-bg App-div-content">
                      <NavTop/>

                        <h1 className="App-presentation-title">
                            WELCOME TO<br/>
                            YOUR OWN<br/>METAVERSE<br/><br/><br/>
                        </h1>
                </div>
                    </Container>
                    <div className="container fluid pb-5 pt-5" >
                        <div className="section-div-dark"><br/><br/><br/><br/><br/></div>
                        <div className="section-div-dark"><br/><br/><br/><br/><br/></div>
                        <div className="section-div-dark"><br/><br/><br/><br/><br/></div>
                        <div className="section-div-dark"><br/><br/><br/><br/><br/></div>
                    <Row>
                        <Col md={4}>
                            <div className="App-info">
                                <Card.Body>
                                    <Card.Header><Bezier2 className="text-danger" size={76}/></Card.Header>
                                    <Card.Title>Build Your Own Metaverse</Card.Title>
                                    <Card.Text>
                                        Metaframe&trade; a freely distributed token that enables you to participate in the next generation of a decentralized metaverse running on the blockchain.
                                    </Card.Text>
                                </Card.Body>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="App-info">
                                <Card.Body>
                                    <Card.Header><KanbanFill className="text-danger" size={76}/></Card.Header>
                                    <Card.Title>The Project</Card.Title>
                                    <Card.Text>
                                        Metaframe&trade; gives you access to the framework for you to create your own metaverse world in just a few clicks, using one of the basic pre-made Metaverses that are easily customizable for your personal experience.
                                    </Card.Text>
                                </Card.Body>
                            </div>
                        </Col>
                        <Col>
                            <div className="App-info">
                                <Card.Body>
                                    <Card.Header><ShareFill className="text-danger" size={76}/></Card.Header>
                                    <Card.Title>Jump Between Worlds</Card.Title>
                                    <Card.Text>
                                        When you create your metaverse, you also have the possibility to create a portal to other metaverses created using a decentralized app.
                                    </Card.Text>
                                </Card.Body>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="section-div-dark"> </div>
                <div className="App-background-gray">
                <div className="section-div-gray"> </div>
            <Container fluid>
                <Row>
                    <Col>
                        <h3 className="App-point-title">
                            Your own Metaverse
                        </h3>
                        <div className="section-div-gray"> </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <div className="App-description">
                        <WalletFill className="text-danger" size={76}/>
                        <h5>
                            <br/>Metaframe allows you to create your own world<br/>
                        </h5>
                    </div> </Col>
                    <Col ><Image  src="metaframe-image1.jpg" thumbnail  /></Col>
                    <Col>

                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <div className="App-description">
                            <CheckSquareFill className="text-danger" size={76}/>
                        <h5>
                            <br/>Use your MTF&trade; tokens to create your own metaverse or improve your world.<br/>
                        </h5>
                        </div>
                    </Col>
                    <Col><div className="App-description">
                            <ArrowRepeat className="text-danger" size={76}/>
                        <h5>
                        <br/>Keep returning to the site so you don't miss the opportunity of being part of Metaframe&trade;.
                        </h5><br/><br/>
                        </div>
                    </Col>
                    <Col> </Col>
                </Row>
            </Container>
                    <div className="section-div-gray"> </div>
                </div>
                <div className="section-div-dark"> </div>
            <div className="App-background-dark">
                <Container fluid>
                    <Row>
                    <Col>
                        <h3 className="App-point-title">
                            Roadmap
                        </h3>
                        <div className="section-div-dark"> </div>
                    </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Roadmap/>
                        </Col>
                    </Row>
                </Container>
                <div className="section-div-dark"> </div>
                <Container fluid>
                    <Row>
                        <Col>
                            <div className="App backColor App-font">
                                <NavBottom/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            </div>
        );
    }
}

export default App;
